<span class="button-wrapper" data-sirius-button-wrapper>
    <span class="button-content" data-sirius-button-content>
        @if (buttonText) {
            <span class="button-text">{{ buttonText }}</span>
        }
        @if (iconName) {
            <sirius-icon [name]="iconName" [attr.aria-hidden]="buttonText ? 'true' : null"></sirius-icon>
        }
    </span>
    <ng-content></ng-content>
</span>
